  import { lazy } from "react";
  import routes from "./routesConfig/index";
  
  const InsurancePage = lazy(() => import("../insurance/InsurancePage"));
  
  const insuranceRoutes = [
    { path: routes.insurances, component: InsurancePage, moduleKey: "insurance", permissionKey: "insurance_access" },
  ];
  
  export default insuranceRoutes;

